// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
window.moment = require('moment');
require('daterangepicker');
window.numeral = require('numeral');

window.numeral.register(
    'locale', 'ru', {
        delimiters: {
            thousands: '`',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'тыс',
            million: 'млр',
            billion: 'ярд',
            trillion: 'дох'
        },
        ordinal : function (number) {
            return 'й';
        },
        currency: {
            symbol: '₽'
        }
    }
);

window.numeral.locale('ru');

import './extensions'
import './polyfill'
import './globals'
import {STORE} from './store'
import Vue from 'vue'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router/index'
import VueResource from 'vue-resource'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'
import ru from 'vee-validate/dist/locale/ru';
import VeeValidate, { Validator } from 'vee-validate';
import {veeValidateConfig} from './validate'
import {CONSTANTS} from '@/constants';
import VueMultiselect from 'vue-multiselect';
import i18n from '@/i18n'
// https://github.com/se-panfilov/mini-toastr
// import cssVars from 'css-vars-ponyfill'

// import VueLodash from 'vue-lodash'
// const options = { name: 'lodash' }; // customize the way you want to call it
// Vue.use(VueLodash, options); // options is optional

/********************************************************************************************************************
 * VCalendar
 */

import VCalendar from 'v-calendar';
//import 'v-calendar/lib/v-calendar.min.css'

Vue.use(VCalendar, {
    //firstDayOfWeek: 2,
    //datePickerShowDayPopover: true,
    //showLinkedButtons:true,
    //navVisibility:'focus',
    datePicker:{
        popover:{
             visibility:'focus',
             //placement:'bottom'
         }
     }
});

/********************************************************************************************************************
 * vSelect
 */

import vSelect from 'vue-select'
Vue.component('v-select', vSelect);


/********************************************************************************************************************
 * TOASTR
 */

const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
};
miniToastr.init({types: toastTypes});
function toast ({title, message, type, timeout, cb}) {
    timeout = 10000;
    return miniToastr[type](message, title, timeout, cb)
}
window.toastr = toast;
const notificationOptions = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
};
Vue.use(VueNotifications, notificationOptions);

/********************************************************************************************************************
 *      vue-tables-2
 */

import {ClientTable, ServerTable, Event} from 'vue-tables-2';
Vue.use(ClientTable);
Vue.use(ServerTable);

/********************************************************************************************************************
 *
 */

Vue.use(VeeValidate, veeValidateConfig);
Vue.use(VueResource);
Vue.use(Vuex);

Vue.config.ignoredElements = ['b-field', 'b-autocomplete'];

// todo
// cssVars()

Vue.prototype.$eventHub = new Vue(); // Global event bus

Vue.use(BootstrapVue);

String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

Vue.filter('linebreaksbr', function (value) {
    if (typeof value !== 'string') return value;
    return value.replaceAll("\r\n", '<br>').replaceAll("\n", '<br>').replaceAll("\r", '<br>');
});

const store = new Vuex.Store(STORE);

Vue.filter('formatSize', function (size) {
    if (size > 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
    } else if (size > 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
    } else if (size > 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + ' MB'
    } else if (size > 1024) {
        return (size / 1024).toFixed(2) + ' KB'
    }
    return size.toString() + ' B'
});

Vue.component('multiselect', {
    mixins: [VueMultiselect],
    props: {
        placeholder:            { default: CONSTANTS.MULTISELECT_GLOBAL_CONFIG.placeholder },
        tagPlaceholder:         { default: CONSTANTS.MULTISELECT_GLOBAL_CONFIG.tagPlaceholder },
        selectLabel:            { default: CONSTANTS.MULTISELECT_GLOBAL_CONFIG.selectLabel },
        selectGroupLabel:       { default: CONSTANTS.MULTISELECT_GLOBAL_CONFIG.selectGroupLabel },
        selectedLabel:          { default: CONSTANTS.MULTISELECT_GLOBAL_CONFIG.selectedLabel },
        deselectLabel:          { default: CONSTANTS.MULTISELECT_GLOBAL_CONFIG.deselectLabel },
        deselectGroupLabel:     { default: CONSTANTS.MULTISELECT_GLOBAL_CONFIG.deselectGroupLabel },
    }
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    i18n,
    router,
    store:store,
    template: '<App/>',
    components: {
        App
    }
});

